module.exports = __webpack_public_path__ + "img/ke.kec70195b.svg";